const MemberPages = ['DOB Validation', 'Terms and Conditions', 'Personal Details', 'Choose OTP Method', 'OTP Authorization', 'Create User ID', 'Create Password'];
const ProspectPages = ['Terms and Conditions', 'Personal Details', 'Choose OTP Method', 'OTP Authorization', 'Create User ID', 'Create Password'];

export {MemberPages, ProspectPages};